import { Component, Inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FeedStockLoadAdditionalRevenue } from '../../../../interfaces/pricematrixmodel';
import { ExpenseTypeResponse } from '../../../../interfaces/feeCategoryLookupResponse';
import { MatIconModule } from "@angular/material/icon";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { numericInputLimit } from '../../../shared/commonutils/helper';
import { DragDropModule } from '@angular/cdk/drag-drop';

export interface AddEditRevenueDialogData {
    
  data: FeedStockLoadAdditionalRevenue | null;
  expenseTypes: ExpenseTypeResponse[];
  disableCheckbox: boolean;
  canSave: boolean;
}

@Component({
  selector: 'app-add-edit-revenue-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    DragDropModule
],
  templateUrl: './add-edit-revenue-dialog.component.html',
  styleUrl: './add-edit-revenue-dialog.component.scss'
})
export class AddEditRevenueDialogComponent implements OnInit {
  canSave: boolean = false;
  editForm!: FormGroup;
  disbleBilToCustomer: boolean = false;
  displayValue=signal<string>('');

  constructor(
    public dialogRef: MatDialogRef<AddEditRevenueDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: AddEditRevenueDialogData,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    
    const revenueItem = this.dialogData.data;
    console.log("Revenue edit data", this.dialogData);
    this.canSave = this.dialogData.canSave;
    this.editForm = this.fb.group({
      id: [revenueItem?.id || 0],
      name: [revenueItem?.name, Validators.required],
      invoiceNumber: [revenueItem?.invoiceNumber, Validators.required],
      price: [revenueItem?.price, [Validators.required]],
      expensive: [revenueItem?.expensive || false],
      expenseType: [revenueItem?.expenseType, [Validators.required]],
      fsLoadScheduleId: [revenueItem?.fsLoadScheduleId]
    });
    if (this.dialogData.disableCheckbox) {
      this.editForm.get('expensive')?.disable();
    }
  }
  
  onSave(): void {
    if (this.editForm.valid) {
      this.dialogRef.close(this.editForm.value);
    }else{
      this.editForm.markAllAsTouched();
    }
  }
  
  onClose(): void {
    this.dialogRef.close(false);
  }
  roundOff(event: Event, maxValue: number, maxDecimals: number, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;
    
    val = numericInputLimit(event, maxValue, maxDecimals);
    
    this.displayValue.set(val);
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.';
    if (isValueEmpty) {
      this.editForm.get(controlName)?.setValue(null, { emitEvent: false });
    } else if (val.endsWith('.')) {
      this.editForm.get(controlName)?.setErrors({ 'incompleteDecimal': true });
    } else {
      const parsedValue = parseFloat(val);
      this.editForm.get(controlName)?.setValue(parsedValue, { emitEvent: false });
    }

    requestAnimationFrame(() => {
      if (document.activeElement === input) {
        input.value = val;   // put "14.10" back so next keystroke appends correctly
      }
    });
  }
}
